import { createElement } from 'rax';
import Typography from './typography';
const MAP = {
    h1: 'headline',
    h2: 'title',
    h3: 'subhead',
    h4: 'subhead',
    h5: 'body-2',
    h6: 'body-1',
};
export default function (type) {
    const Title = (props) => {
        return <Typography {...props} type={MAP[type]} strong/>;
    };
    Title.displayName = type.toUpperCase();
    return Title;
}
